import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import Check2Icon from "../../Icons/Check2Icon";
import { AcceptStudentRequest } from "../../../api/Courses/AcceptRequest";
import { queryClient } from "../../../main";
const StudentRequestRow = ({
  fullName,
  studentStatus,
  phone,
  courseName,
  status,
  coursePrice,
  currency,
  requestId
}: {
  fullName?: string;
  email?: string;
  joinedAt?: string;
  phone?: string | number | null;
  country?: string;
  courseName?: string;
  status?: string;
  coursePrice?: number;
  currency:string;
  studentStatus?: string;
  requestId:string;
}) => {
  const { mutate } = useMutation({
    mutationFn: AcceptStudentRequest,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["requests"] });
      toast.success("Student Added To Course Successfully");
    },
    onError: () => {
      toast.error(`Student already assigned to course`);
    },
  });
  const handleAssignCourse = () => {
    mutate({
      requestId: requestId,
    });
  };

  return (
    <tr>
      <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
        <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold ">
          {fullName}
        </div>
      </td>
      <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
        <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
          {phone}
        </div>
      </td>
      <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
        <div
          className={`inline-flex capitalize  rounded-full py-1.5 px-3 text-sm font-semibold ${
            studentStatus === "inactive" ? " text-red-500" : " text-green-500"
          }`}
        >
          {studentStatus}
        </div>
      </td>
      <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
        <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
          {courseName}
        </div>
      </td>

      <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
        <div className="inline-flex rounded-full text-left py-0.5 text-sm font-semibold">
          {coursePrice} {currency}
        </div>
      </td>

      <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
        <div
          className={`capitalize mx-auto rounded-full text-center py-1.5 px-3 text-sm font-semibold ${
            status === "pending"
              ? "bg-red-100 text-red-500"
              : "bg-green-100 text-green-500"
          }`}
        >
          {status}
        </div>
      </td>
      <td className=" px-2 first:pl-5 last:pr-5  py-3 whitespace-nowrap">
        <button
          onClick={handleAssignCourse}
          className="mx-auto rounded flex items-center justify-center text-left py-0.5 text-sm font-semibold w-7 h-7 bg-lightGray/5 border-primary border "
        >
          <Check2Icon />
        </button>
      </td>
    </tr>
  );
};

export default StudentRequestRow;
